import { inject, Injectable } from '@angular/core';

import { restManager } from 'app/ajs-upgraded-providers';

import { ConfigurationPreferences, CoreStateService } from 'src/app/core';
import { ConfirmDialogService } from 'src/app/dialogs';

/** What has to be done after some preferences have been saved. */
@Injectable()
export class SettingsHubPostSaveService {
    private readonly confirmDialogService = inject(ConfirmDialogService);
    private readonly coreStateService = inject(CoreStateService);
    private readonly restManagerService = inject(restManager);

    async handle(savedKeys: (keyof ConfigurationPreferences)[]) {
        // The server prepares 4Dem when the api key changes
        if (savedKeys.includes('fdem_apikey')) {
            try {
                await this.restManagerService.getOne('four_dem', 'check');
            } catch (error) {
                // The check can be repeated by forcing the synchronization
            }
        }

        // The local server reads its settings only at startup
        if (savedKeys.some(key => key.startsWith('local_server'))) {
            const restart = await this.confirmDialogService.openDialog({ data: { messageLabel: 'SETTINGS.SETTINGS.RESTART_CONFIRM' } });

            if (restart) {
                this.coreStateService.restartApplication();
            }
        }
    }
}
